export default "__VITE_ASSET__f1031ab8__"